import { css } from '@emotion/css';
import {
  Spacing,
  AlignItems,
  JustifyContent,
  Display,
  Color,
  Font,
  FontWeight,
  TextAlign,
  BaseStyle,
  SpaceSize,
} from 'src/styles';

export const space = css`
  && {
    ${Spacing.mr4}
  }
`;

export const alreadyHaveAccountLabel = css`
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
  ${Font.lg}
  ${TextAlign.center}
  ${Spacing.my16}
`;

export const description = css`
  ${Font.lg}
  ${TextAlign.center}
  color: ${Color.Gray9};
  ${BaseStyle.clearFix}
`;

export const linkButton = css`
  ${Font.lg}
  ${BaseStyle.clickable}
  ${FontWeight.bold}
  color: ${Color.Brand6};
`;

export const link = css`
  ${Font.lg}
  color: ${Color.Brand6};
  ${BaseStyle.clickable}
  ${Spacing.mt16}
  ${Display.block}
`;

export const formItemsContainer = css`
  ${Spacing.my20}
`;

export const formTitle = css`
  ${FontWeight.bold}
  ${Font.h6}
  && {
    ${Spacing.mb32}
  }
  color: ${Color.Gray9};
`;

export const iconContainer = css`
  ${Display.flex}
  ${JustifyContent.center}
  ${AlignItems.center}
  width: 5rem;
  height: 5rem;
  background: ${Color.Green1};
  border-radius: 5rem;
  ${Spacing.mt40}
  ${Spacing.mb8}
`;

export const afterActionTitle = css`
  ${Font.lg}
  ${FontWeight.bold}
  ${TextAlign.center}
  && {
    ${Spacing.mb8}
  }
  color: ${Color.Green7};
`;

export const afterActionSubtitle = css`
  ${Font.md}
  ${TextAlign.center}
  && {
    ${Spacing.mb40}
  }
  color: ${Color.Gray7};
  width: 100%;
`;

export const resendContainer = css`
  ${Spacing.mt32}
  ${Spacing.mb16}
  min-height: ${SpaceSize.is40}
`;

export const resendCodeButton = css`
  ${Font.md}
  ${Spacing.p0}
  color: ${Color.Brand6};
`;

export const myCrsFormLinkContainer = css`
  ${alreadyHaveAccountLabel}
  ${Display.flex}
  ${AlignItems.center}
  ${JustifyContent.center}
  ${Spacing.mt32}
  a {
    text-decoration: underline;
  }
`;

export const referrerCard = css`
  ${Spacing.mb40}
`;

export const referrerSubtitle = css`
  ${Spacing.mb0}
`;

export const referrerSubtitleParagraph = css`
  ${Font.h5}
  ${FontWeight.semibold}
`;

export const referrerStep = css`
  ${Font.h6}
  ${TextAlign.left}
`;
